import api from "../api";

export default {
    store(data) {
        return api.post('/central/venues', data)
    }
}